import PropTypes from "prop-types";

export const CtaLinks = ({ cta, style = {} }) => {
  return (
    <div className="footer-content--links-box">
      {cta?.filter(Boolean)?.map(({ text, link, newTab }, i) => (
        <a
          key={`${link.staticValue}-${i}`}
          href={link.staticValue}
          target={newTab?.staticValue ? "_blank" : "_self"}
          className="footer-content--link"
          style={style}
        >
          <p className="body-m-high">{text.staticValue}</p>
        </a>
      ))}
    </div>
  );
};

CtaLinks.propTypes = {
  style: PropTypes.object,
  cta: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.shape({
        staticValue: PropTypes.string,
      }),
      link: PropTypes.shape({
        staticValue: PropTypes.string,
      }),
      newTab: PropTypes.shape({
        staticValue: PropTypes.bool,
      }),
    })
  ),
};
